export const EXPERIMENT_TEXT_RATES = 'MS-bgr20RjCOtYM8-MV9Nw';
export const EXPERIMENT_TEXT_RATES_ACTIVATE = { event: 'optimize.activate-text-experiment' };

/**
 * Checks to see the current experiment value for a requested
 *   experiment id.
 *
 * Returns undefined if not a part of the experiment. Returns
 *   the experiment value otherwise.
 *
 * For example, a simple A/B test would be false if in the A
 *   group, true if in the B group, or undefined if not in
 *   the experiment.
 *
 * @param {*} experimentId - Experiment Id to check.
 */
export const getExperimentValue = (experimentId) => {
  const optimize = window.google_optimize;
  if (optimize) {
    return optimize.get(experimentId);
  }
  return undefined;
};

/**
 * Triggers an event to evaluate the user's experiment participation.
 *   These must be raised as on an SPA google optimize cannot
 *   correctly auto-inject the user.
 *
 * Returns true if the experiment was activated. Returns false
 *   if it was not (which can be caused by either them not
 *   meeting the criteria or the experiment already being
 *   activated.)
 *
 * The way to check for a user's experiment status is by
 *   getting the experiment value after.
 *
 * @param {*} experimentPayload - activation payload
 */
export const activateExperiment = (experimentPayload) => {
  const dataLayer = window.dataLayer;
  if (dataLayer) {
    return dataLayer.push(experimentPayload);
  }
  return undefined;
};



// WEBPACK FOOTER //
// ./src/modules/experiments/optimize.js